export function createRadarWorldTransform(source) {
    if (!Number.isFinite(source.posXHu) ||
        !Number.isFinite(source.posYHu) ||
        !Number.isFinite(source.scaleHuPerPixel) ||
        source.scaleHuPerPixel <= 0 ||
        !Number.isInteger(source.widthPixels) ||
        source.widthPixels <= 0 ||
        !Number.isInteger(source.heightPixels) ||
        source.heightPixels <= 0) {
        throw new RangeError("Valve overview transform source is invalid");
    }
    return {
        originHu: { x: source.posXHu, y: source.posYHu, z: 0 },
        xAxisHu: {
            x: source.widthPixels * source.scaleHuPerPixel,
            y: 0,
            z: 0,
        },
        yAxisHu: {
            x: 0,
            y: -source.heightPixels * source.scaleHuPerPixel,
            z: 0,
        },
    };
}
export function radarPointToWorld(transform, point, heightOffsetHu = 0) {
    const xRatio = point.x / 1000;
    const yRatio = point.y / 1000;
    return {
        x: transform.originHu.x +
            transform.xAxisHu.x * xRatio +
            transform.yAxisHu.x * yRatio,
        y: transform.originHu.y +
            transform.xAxisHu.y * xRatio +
            transform.yAxisHu.y * yRatio,
        z: transform.originHu.z +
            transform.xAxisHu.z * xRatio +
            transform.yAxisHu.z * yRatio +
            heightOffsetHu,
    };
}
export function worldPointToRadar(transform, point) {
    const determinant = transform.xAxisHu.x * transform.yAxisHu.y -
        transform.xAxisHu.y * transform.yAxisHu.x;
    if (!Number.isFinite(determinant) || Math.abs(determinant) <= 1e-9) {
        throw new RangeError("radar transform axes are not invertible");
    }
    const deltaX = point.x - transform.originHu.x;
    const deltaY = point.y - transform.originHu.y;
    const normalizeZero = (value) => (Object.is(value, -0) ? 0 : value);
    return {
        x: normalizeZero(((deltaX * transform.yAxisHu.y - deltaY * transform.yAxisHu.x) /
            determinant) *
            1000),
        y: normalizeZero(((transform.xAxisHu.x * deltaY - transform.xAxisHu.y * deltaX) /
            determinant) *
            1000),
    };
}
export function findMapHeightLayer(layers, zHu) {
    if (!Number.isFinite(zHu))
        throw new RangeError("zHu must be finite");
    const highestZ = Math.max(...layers.map((layer) => layer.maxZHu));
    return (layers.find((layer) => zHu >= layer.minZHu && (zHu < layer.maxZHu || zHu === highestZ)) ?? null);
}
